export const CONSONANT_VOWEL_PAIRS_R_L = [

    // ㄴ
    {
        id: 1,
        korean: "라",
        english: "ra",

    },
    {
        id: 2,
        korean: "레",
        english: "re",

    },
    {
        id: 3,
        korean: "리",
        english: "ri",

    },
    {
        id: 4,
        korean: "로",
        english: "ro",

    },
    {
        id: 5,
        korean: "르",
        english: "reu",

    },
    {
        id: 6,
        korean: "러",
        english: "reo",

    },
    {
        id: 7,
        korean: "랴",
        english: "rya",

    },
    {
        id: 8,
        korean: "래",
        english: "rae",

    },
    {
        id: 9,
        korean: "례",
        english: "rye",

    },
    {
        id: 10,
        korean: "료",
        english: "ryo",

    },
    {
        id: 11,
        korean: "려",
        english: "ryeo",

    },
    {
        id: 12,
        korean: "류",
        english: "ryu",

        

    },

    {
        id: 13,
        korean: "란",
        english: "ran", 

    },
    {
        id: 14,
        korean: "락",
        english: "rak",

        

    },
    {
        id: 15,
        korean: "림",
        english: "rim",
        

    },
    {
        id: 16,
        korean: "랏",
        english: "rat",
        

    },
    {
        id: 17,
        korean: "랗",
        english: "rah",
        

    },
    {
        id: 18,
        korean: "럽",
        english: "reob",
        

    },
          {
        id: 19,
        korean: "를",
        english: "reul",
        

    },
    {
        id: 20,
        korean: "랖",
        english: "rap",
        

    },
    {
        id: 21,
        korean: "랚",
        english: "raekk",
        

    },
    {
        id: 22,
        korean: "랜",
        english: "raen",
        

    },
    {
        id: 23,
        korean: "뢰",
        english: "rui",
        

    },
    {
        id: 24,
        korean: "룸",
        english: "rum",
        

    },

    {
        id: 25,
        korean: "럍",
        english: "ryat",
        

    },
    {
        id: 26,
        korean: "랓",
        english: "rat",
        

    },
    {
        id: 27,
        korean: "랑",
        english: "rang",
        
    },
    {
        id: 28,
        korean: "랄",
        english: "ral",
        
    },
    {
        id: 29,
        korean: "렬",
        english: "ryeol",
        
    },
    {
        id: 30,
        korean: "알",
        english: "al",
        
    },
    {
        id: 31,
        korean: "렇",
        english: "reoh",
        
    },
    {
        id: 32,
        korean: "를",
        english: "reul",
        
    },
        {
        id: 33,
        korean: "뤄",
        english: "rwo",
        
    },
        {
        id: 34,
        korean: "륲",
        english: "ryup",
        
    },
        {
        id: 35,
        korean: "랄",
        english: "ral",
        
    }

    
];

